import React from 'react';
import { motion } from 'framer-motion';
import { RadiantStar } from './ui/RadiantStar';
export function WelcomeSection() {
  return <section className="relative py-24 overflow-hidden" data-id="element-201">
      {/* Decorative Star */}
      <div className="absolute top-10 right-10 opacity-60 pointer-events-none hidden md:block" data-id="element-202">
        <RadiantStar size={48} delay={0.5} data-id="element-203" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-204">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-205">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-206">
            <h2 className="font-serif text-4xl md:text-5xl text-gold-400 mb-6" data-id="element-207">
              This is where your next adventure begins
            </h2>

            <div className="space-y-6 text-cream-50/90 text-lg leading-relaxed" data-id="element-208">
              <p data-id="element-209">
                We support individuals who feel overwhelmed, stuck, or at a
                crossroads.
              </p>
              <p data-id="element-210">
                Modern life constantly pulls us toward expectations, pressure,
                endless choices, social media, and FOMO, leaving little space to
                reflect on what truly matters to you.
              </p>
              <p data-id="element-211">
                Through partnership-based coaching, we help you slow down,
                regain clarity, and reconnect with the direction that feels
                right for you.
              </p>
              <p data-id="element-212">
                Our 4-step coaching journey combines reflection, future focus,
                and practical action to help you make confident decisions and
                build a life that truly feels like yours.
              </p>

              {/* Closing quote-like statement */}
              <div className="pt-4 border-l-2 border-gold-400/50 pl-5" data-id="element-213">
                <p className="font-serif italic text-xl md:text-2xl text-cream-50 leading-relaxed" data-id="element-214">
                  Because true transformation is not about changing who you are.
                  It's about remembering who you've always been.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-215">
            <div className="absolute inset-0 bg-gold-400/20 rounded-lg transform rotate-3" data-id="element-216"></div>
            <img src="https://cdn.magicpatterns.com/uploads/hkHEmTH4JHdibv3c59UUah/Panoramic_Composition_Of_Baobab_Trees_Along_Baobab_Alley_At_Sunset_Near_Morondava,_Madagascar_dreamstime_xxl_129751562_(1).jpg" alt="Avenue of Baobab trees at sunset in Madagascar" className="relative rounded-lg shadow-2xl w-full h-auto object-cover aspect-[4/3]" data-id="element-217" />
          </motion.div>
        </div>
      </div>
    </section>;
}